export default __webpack_public_path__ + "static/media/category_19.8298cd03.png";